module.exports = __webpack_public_path__ + "static/media/assembly_hover.1f5411f0.svg";